// eslint-disable-next-line import/prefer-default-export
export const NUU_COOKIE_CLIENT_ID = 'x_nuuly_clientId';
